/*
 * @Author: your name
 * @Date: 2021-06-07 10:32:07
 * @LastEditTime: 2025-07-17 09:10:19
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\store\mutation-types.js
 */
export const INIT_BUYCART = 'INIT_BUYCART';
export const ADD_CART = 'ADD_CART';
export const GET_USERINFO = 'GET_USERINFO';
export const RECORD_USERINFO = 'RECORD_USERINFO';
export const ADD_ANIMATION = 'ADD_ANIMATION';
export const SHOW_CART = 'SHOW_CART';
export const REDUCE_CART = 'REDUCE_CART';
export const EDIT_CART = 'EDIT_CART';
export const INFO_CART = 'INFO_CART';
export const SITE_LIST = 'SITE_LIST';
export const NEWS_ID = 'NEWS_ID';
export const SEARCH_LIST = 'SEARCH_LIST';
export const COMPANY_CODE = 'COMPANY_CODE';
export const COMPANY_ID = 'COMPANY_ID';
export const COMPANY_NAME = 'COMPANY_NAME';
export const GUESS_PRODUCTS = 'GUESS_PRODUCTS';
export const SEARCH_WORD = 'SEARCH_WORD';

// 分类
export const GET_PRODUCTCATEGORYLIST = 'GET_PRODUCTCATEGORYLIST';
export const GET_PRODUCTCATEGORYLISTNOLOGIN = 'GET_PRODUCTCATEGORYLISTNOLOGIN';
export const CHANGE_ITEM = 'CHANGE_ITEM';
export const GETCUSTOMER = 'GETCUSTOMER';
export const CHANGE_USERINFO = 'CHANGE_USERINFO';
// 保存商品基础信息
export const PRODUCT_LIST = 'PRODUCT_LIST';
export const PRODUCT_LIST_1 = 'PRODUCT_LIST_1';
export const PRODUCT_LIST_2 = 'PRODUCT_LIST_2';
export const CATEGORY_LIST = 'CATEGORY_LIST';
export const PRODUCT_INFO = 'PRODUCT_INFO';
export const TABLE_LIST = 'TABLE_LIST';
export const CREATE_PRODUCT_LIST = 'CREATE_PRODUCT_LIST';
export const HADNDLE_COLLAPSE = 'HADNDLE_COLLAPSE';

// 数据存储
export const USER_INfO = 'USER_INfO'; // 用户信息
export const BRAND_INfO = 'BRAND_INfO'; // 商城信息
export const GET_LOGO_IMG_LIST = 'GET_LOGO_IMG_LIST'; // 采购专属商城logo

// 新手引导
export const SHOW_LIB = 'SHOW_LIB';

// 路由参数加密
export const ROUTER_PARAMS = 'ROUTER_PARAMS';

// 采购产品范围
export const IS_PROTOCOL = 'IS_PROTOCOL';
